import { tryParseInt } from '@witkac/utils/tryParseInt';
import { RouteConfig } from 'vue-router';

import RouterView from '@/components/RouterView.vue';
import { BenefitChangeState } from '@/enums/benefitChangeState';
import store from '@/store/store';
import { benefitTabFilters } from '@/utils/benefitTabFilters';
import BenefitDetails from '@/views/benefit/Details.vue';
import BenefitList from '@/views/benefit/List.vue';
import { PublicSettings } from '@witkac/kartamiejska-shared';

export const benefitRoute: RouteConfig = {
  path: 'benefits',
  name: 'benefits',
  component: RouterView,
  redirect: { name: 'benefitList', params: { state: BenefitChangeState.ACTIVE } },
  children: [
    {
      path: ':state',
      name: 'benefitList',
      component: BenefitList,
      beforeEnter: (to, from, next) => {
        const filters = benefitTabFilters(to, store);
        Promise.all([
          store.dispatch('benefit/list', filters),
          store.dispatch('settings/settingFindPublic', 'BENEFIT_CONFIRM'),
          store.dispatch('settings/settingFindPublic', PublicSettings.NO_GROUP_SELECTED_NAME)
        ])
          .then(() => next())
          .catch(() => store.dispatch('notifyError', { title: 'Nie udało się pobrać listy usług.' }));
      },
      meta: { toolbarTitle: 'Usługi' }
    },
    {
      path: ':state/:benefitId',
      name: 'benefitDetails',
      component: BenefitDetails,
      beforeEnter: (to, from, next) => {
        store.commit('breadcrumbs/set', [
          { text: 'Usługi', to: { name: 'benefits' }, exact: true },
          { text: 'Usługa do akceptacji', disabled: true }
        ]);
        Promise.all([
          store.dispatch('benefit/get', tryParseInt(to.params.benefitId)),
          store.dispatch('settings/settingFindPublic', 'BENEFIT_CONFIRM'),
          store.dispatch('settings/settingFindPublic', PublicSettings.NO_GROUP_SELECTED_NAME)
        ]).then(() => next());
      },
      meta: { toolbarTitle: 'Usługi' }
    }
  ]
};
